import React, { useEffect, useState } from 'react'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import { useNavigate } from 'react-router-dom'
import useFilterTabs from '../hooks/useFilterTabs'
import { Box } from '@mui/material'

const CompanyManagement = ({ initialTab }) => {
  // change state from child to parent
  const [tabIndex, setTabIndex] = useState(0)

  // get from context
  const { filteredTabs } = useFilterTabs()

  // useEffect
  useEffect(() => {
    changeRoute(tabIndex)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabIndex])

  // function to change route based on tabIndex
  const navigate = useNavigate()
  const changeRoute = (index) => {
    if (filteredTabs?.length > 0) {
      navigate(`/app/management-centre/company-management/${filteredTabs[index]?.link}`, {
        state: { tabIndex: tabIndex },
      })
    }
  }

  return (
    <DashboardContainer headerTitle="Company Management">
      <Box
        className="scrollbar"
        sx={{
          bgcolor: 'white.main',
          border: 1,
          borderColor: 'gray-line.main',
          borderRadius: '4.5px',
        }}
      >
        <AdxTabsBadge
          sxPanel={{
            maxHeight: 'calc(100vh - 182px)',
            overflowY: 'auto',
            borderRadius: 0,
            p: { xs: 0, md: 2 },
          }}
          setTabIndex={setTabIndex}
          initialValue={initialTab}
          scrollButtons={true}
          tabsBorderBottom
        >
          {filteredTabs?.map(({ label, component }, index) => (
            <AdxTabsPanel label={label} key={index}>
              {component}
            </AdxTabsPanel>
          ))}
        </AdxTabsBadge>
      </Box>
    </DashboardContainer>
  )
}

export default CompanyManagement
